var render = function render(){var _vm=this,_c=_vm._self._c;return _c('trax-ui-ajax-data-table',{attrs:{"id":_vm.id,"titles":_vm.titles,"props":_vm.props,"cols":_vm.cols,"bus":_vm.bus,"endpoint":_vm.endpoint,"order-column":"4","order-dir":"desc","searching":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }